import { Typography, Stack } from '@mui/material';
import type { ResourceIdentifiers } from '@repo/api-gw-sdk';

import { OverflowTooltip } from '../tooltips/overflowTooltip';

export const ResourceIdentifierItem = ({
  resource,
}: {
  resource: ResourceIdentifiers;
}) => {
  return (
    <Stack
      className='truncate'
      sx={{
        gap: '4px',
        width: '100%',
      }}
    >
      <OverflowTooltip
        shouldCloseOnScroll={true}
        text={resource.providerId}
        renderContent={(text, ref) => (
          <Typography variant='subtitle1' className='truncate' ref={ref}>
            {text}
          </Typography>
        )}
      />
      <OverflowTooltip
        shouldCloseOnScroll={true}
        text={resource.name}
        renderContent={(text, ref) => (
          <Typography
            variant='body2'
            className='truncate'
            ref={ref}
            sx={{
              color: !resource.id ? 'var(--mui-palette-info-main)' : undefined,
            }}
          >
            {text}
          </Typography>
        )}
      />
    </Stack>
  );
};
